import { useFormContext } from 'react-hook-form'

import { InputProps } from '../interfaces'

export default function useInputHidden(props: InputProps): any {
  const { id, name } = props
  const ctx = useFormContext()
  const elemId = id ? id : `id_${name}`
  return { ctx, elemId }
}
